import React from 'react';
import { ExtendedCompleteRiskFields } from '@pages-clean/risk-assessment/risk-log/constants';
import { NullableStudy } from '@contexts/local-state-context';

export interface IFormData {
    study: NullableStudy | undefined;
    selectionState: SelectionState;
    actionsGridIsFiltered: boolean;
    actionsGridFiltersResetToken?: number;
    latestDataset: Date | undefined;
    riskReviewStartDate: Date | undefined;
    risksHaveCmControlsLinked: boolean;
}

export type SelectionState = {
    recordId?: string;
    selectedItemsCount: number;
    bulkUpdateRows: SelectedRowsProps[];
    selectedItem?: ExtendedCompleteRiskFields;
};

export interface SelectedRowsProps {
    id: number;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
    setSelectionState: React.Dispatch<React.SetStateAction<SelectionState>>;
}

export const RiskLogContext = React.createContext<IContext>(undefined!);
